<div class="flex flex-col md:flex-row bg-white h-screen relative overflow-hidden">
    <!-- Mobile Header -->
    <header class="flex md:hidden items-center justify-between px-6 py-4 border-b border-stroke-grey bg-white z-30">
        <div class="flex items-center gap-2">
            <button (click)="toggleMobileSidebar()" class="p-2 -ml-2 rounded hover:bg-selected text-primary cursor-pointer" aria-label="Toggle Menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="4" y1="12" x2="20" y2="12"></line>
                    <line x1="4" y1="6" x2="20" y2="6"></line>
                    <line x1="4" y1="18" x2="20" y2="18"></line>
                </svg>
            </button>
            <span class="font-semibold text-primary">Enterprise AI</span>
        </div>
    </header>

    <!-- Sidebar Backdrop for Mobile -->
    <div *ngIf="isMobileSidebarOpen" (click)="closeMobileSidebar()" class="fixed inset-0 bg-black/40 z-40 md:hidden transition-opacity"></div>

    <!-- Sidebar Wrapper -->
    <div class="fixed inset-y-0 left-0 z-50 md:relative md:z-10 h-screen overflow-hidden transition-all duration-300 ease-in-out bg-white shadow-xl md:shadow-none"
         [ngClass]="[
             isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0',
             isSidebarCollapsed ? 'w-[250px] md:w-[74px]' : 'w-[250px]'
         ]"
    >
        <app-sidebar (toggle)="sidebarToggle($event)"/>
    </div>
    
    <!-- Main Content Area -->
    <main class="flex-1 overflow-y-auto min-w-0">
        <router-outlet/>
    </main>
</div>